import { useQuery } from "@tanstack/react-query";
import { documentosApi, type LimitesDocumentos } from "../services/documentos.api";

/** Mientras carga (o si falla) se usa el valor por defecto · el servidor valida de todos modos. */
const POR_DEFECTO: LimitesDocumentos = { tamanoMaximoMb: 50, tamanoMaximoBytes: 50 * 1024 * 1024 };

/** Tamaño máximo por archivo configurado en el panel de administración. */
export function useLimitesDocumentos(): LimitesDocumentos {
  const { data } = useQuery({
    queryKey: ["documentos", "limites"],
    queryFn: documentosApi.limites,
    staleTime: 5 * 60_000,
  });
  return data ?? POR_DEFECTO;
}
